export const typeList = [
	{ text: "PickUp", id: 1 },
	{ text: "Delivery", id: 2 },
];
